import { FormattedMessage } from 'react-intl';
import DefaultLayout from '../../Layout/DefaultLayout';

export default function HomePage() {
  return <DefaultLayout><h1><FormattedMessage id="HOME" /></h1></DefaultLayout>;
}
